import { FlatPickrDirective } from './../../plugins/flatpickr/flatpickr.directive';
import { FlatPickrModel } from '../../plugins/flatpickr/flatpickr.model';
import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DriverModel, DriverSubscriptionModel } from '../models/driver.model';
import { DriverService } from '../models/driver.service';
import { SharedVehicleGroupService } from '../../sharedvehiclegroup/models/sharedvehiclegroup.service';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute } from '@angular/router';
import { WeGoConfig, IAPIResponse, IKeyValueInterface, ApplicationRouteURL, UserRoles, DataListModel, WeGoAuthorizedLink, Permission, PermissionType } from '../../shared/config';
import { DriverSVGSubscriptionModel } from '../models/driverSVGSubscription.model';
const moment = require("moment");

@Component({
  selector: 'wego-driver-svg-list',
  template: require('../views/driverSVG-list.component.html'),
  providers: [DriverService, SharedVehicleGroupService],
  styles: [`

        .mynewclassclose {
            position: absolute;
            top: -4px;
            right: -4px;
            opacity: 1;
        }
        .mynewclassclose:hover {
            opacity: 1;
        }
        .disCard {
            box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
            transition: 0.3s;
            width: 100%;
            margin-bottom: 10px;
        }
        
        .disCard:hover {
            box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
        }
                
        .disCard .titleBox {
            background-color: #2ba2aa;
            color: #ffffff;
            padding: 15px 15px;
            text-align: center;
        }
        .disCard .titleBox h1 {
            font-size: 28px;
            font-style: normal;
            font-weight: 600;
        }`]
})
export class DriverSVGListComponent implements OnInit {
  public dateFormat: string = WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
  DataListModel: DataListModel;
  sub: any;
  driverSVGList: DriverSVGSubscriptionModel[];
  deleteSVGHashId: string;
  apiErrorMsg: string;
  isLoading: boolean;
  activeFlag: boolean;
  message: string;
  urlDefaultPage: string;
  urlDriverSVGList: string;
  urlDriverList: string;
  driverMasterHashId: string;
  isParentCheck: boolean;
  Message: string;
  sharedvehiclegroupDriverHashId: string;
  bookingList: any;
  DataListBooking: DataListModel;
  flatPickrConfigFrom: FlatPickrModel;
  subScriptionEndDate: string;
  subscriptionvalidationMessage: string;
  driverName: string;
  driverFName: string;
  driverLName: string;
  driverSubscriptionList: DriverSubscriptionModel[];
  driverSubscription: DriverSubscriptionModel;
  urlSubscriptionUpdate: string;
  addSubscriptionLink: WeGoAuthorizedLink;

  private popupMsg: string;
  private module: string;
  private breadCrumbList: string;
  private diverList: string;
  private bookingStillRunningMessage: string;

  @ViewChild('alertModal') public alertModal: any;
  @ViewChild('assignDriverGroupModal') public assignDriverGroupModal: any;
  @ViewChild('affectedbookingModal') public affectedbookingModal: any;
  @ViewChild('successPopup') public successPopup: any;
  @ViewChild('subscriptionDetailModal') public subscriptionDetailModal: any;
  @ViewChild('ConfirmRunningModal') public confirmRunningModal: any;

  constructor(private driverService: DriverService,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private SVGService: SharedVehicleGroupService,
    private authService: AuthService, private translate: TranslateService) {
  }

  ngOnInit() {
    this.module = this.translate.instant('LblDriverSVG');
    this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
    this.diverList = this.translate.instant('LblListPage', [this.translate.instant('LblDriver')]);
    this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.DataListModel.searchField = ["groupName", "organizationName", "subScription"];
    this.DataListBooking = new DataListModel();
    this.DataListBooking.searchField = ["licenceTag", "bookingReferenceID", "driver","translatedBookingType","translatedBookingStatus"];

    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.urlDriverSVGList = this.authService.GetURL(ApplicationRouteURL.URL_DRIVER_SVG_LIST);
    this.urlDriverList = this.authService.GetURL(ApplicationRouteURL.URL_DRIVER_LIST);
    this.urlSubscriptionUpdate = this.authService.GetURL(ApplicationRouteURL.URL_SUBSCRIPTION_UPDATE);
    this.bookingStillRunningMessage = this.translate.instant('LblSubscriptionEndOnBookingEnd');

    this.sub = this.activeRoute
      .params
      .subscribe(params => {
        this.driverMasterHashId = params['id'] || '';
        if (this.driverMasterHashId != '') {
          this.GetDriverSVGList();
        }
      });
    this.GetDriverName();
    this.addSubscriptionLink = new WeGoAuthorizedLink("", 
      Permission.PR_DRIVER_SHARED_VEHICLE_GROUP_OVERVIEW, PermissionType.INSERT,'btn btn-highlight navbar-right', 'LblAddNew');
  }
  private SetDefaultFlatPickrConfig() {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.minDate = new Date(new Date().setHours(0, 0, 0));
    flatPickrConfig.dateFormat = this.dateFormat;
    flatPickrConfig.minuteIncrement = 1;
    return flatPickrConfig;
  }
  public GetDriverSVGList() {
    this.isLoading = true;
    this.driverService.GetDriverSVGList(this.driverMasterHashId, this.DataListModel)
      .subscribe(
      res => {
        this.driverSVGList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }
  public GetDriverName() {
    this.isLoading = true;
    this.driverService.GetDriverByHashId(this.driverMasterHashId)
      .subscribe(
      res => {
        this.driverFName = res.data.firstName;
        this.driverLName = res.data.lastName;
        this.driverName = res.data.driverName;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }
  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetDriverSVGList();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
    this.GetDriverSVGList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetDriverSVGList();
  };

  public OnPagingChange(event: any) {
    console.log(this.DataListModel);
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetDriverSVGList();
  }

  public OnExport(event: any) {
    this.isLoading = true;
    this.driverService.ExportDriverSVGList(this.driverMasterHashId)
      .subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "Driver_SVG" + new Date().toISOString() + ".csv";
          this.authService.DownloadFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public UnsubscribeDriverSVG() {
    this.isLoading = true;
    this.driverService.UnsubscribeDriverSVG(this.sharedvehiclegroupDriverHashId, this.subScriptionEndDate)
      .subscribe(
      res => {
        this.DataListModel.currentPage = 1;
        this.GetDriverSVGList();
        this.popupMsg = this.translate.instant('LblUnscubscribeSuccess');
        this.ShowSuccessPopup();
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }
  public OnSortBooking(sortName: string) {
    this.DataListBooking.sortType = sortName;
    this.DataListBooking.sortReverse = !this.DataListBooking.sortReverse;
    this.GetAffectedSubscriptionBookingListForSearch();
  }

  public OnSearchBooking(event: any) {
    this.DataListBooking.searchTerm = event.searchTerm;
    this.DataListBooking.currentPage = 1;
    this.GetAffectedSubscriptionBookingListForSearch();
  }

  public OnPageChangedBooking(event: any): void {
    this.DataListBooking.currentPage = event.page;
    this.GetAffectedSubscriptionBookingListForSearch();
  };

  public CheckBookingInRunningStage(sharedvehiclegroupHashId: string) {
    this.driverService.CheckBookingInRunningStage(sharedvehiclegroupHashId, this.driverMasterHashId)
      .subscribe(
      res => {
        if (res.totalRecords == 0 && res.data == false) {
          this.alertModal.show();
        }
        else {
          this.confirmRunningModal.show();
        }
      });
  }  
  public ConfirmDeleteModalClick()
  {
    this.subScriptionEndDate = moment().format('DD-MM-YYYY HH:mm');
    this.HideDeleteModalClick();
    this.GetAffectedSubscriptionBookingList();
  }

  public HideDeleteModalClick()
  {
    this.confirmRunningModal.hide();
  }

  public GetAffectedSubscriptionBookingList() {
    this.isLoading = true;
    this.driverService.GetAffectedSubscriptionBookingList(this.sharedvehiclegroupDriverHashId, this.subScriptionEndDate, this.DataListBooking)
      .subscribe(
      res => {
        if (res.totalRecords > 0) {
          this.bookingList = res.data;
          this.DataListBooking.totalItems = res.totalRecords;
          this.DataListBooking.infoMessage = res.error;
          this.affectedbookingModal.show();
          this.isLoading = false;
        }
        else {
          // this.alertModal.show();
          this.UnsubscribeDriverSVG();
          this.isLoading = false;
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public OnConfirm(): void {
    this.UnsubscribeDriverSVG();
    this.affectedbookingModal.hide();
  }
  public ShowAlertModal(sharedvehiclegroupDriverHashId: string, sharedvehiclegroupHashId: string): void {
    this.sharedvehiclegroupDriverHashId = sharedvehiclegroupDriverHashId;
    this.subScriptionEndDate = '';
    this.subscriptionvalidationMessage = '';
    this.CheckBookingInRunningStage(sharedvehiclegroupHashId);
  }

  public HideAlertModal(): void {
    this.alertModal.hide();
  }

  public SuccessAlertModalClick(): void {
    if (this.subScriptionEndDate) {
      this.GetAffectedSubscriptionBookingList();
      this.alertModal.hide();
    }
    else {
      this.subscriptionvalidationMessage = this.translate.instant('LblSubscriptionEndDateError');
    }
  }

  public ShowSubscriptionDetailModal(sharedvehiclegroupDriverHashId: string): void {
    this.sharedvehiclegroupDriverHashId = sharedvehiclegroupDriverHashId;
    this.GetDriverSubscriptionDetail();
    this.subscriptionDetailModal.show();
  }

  public HideSubscriptionDetailModal(): void {
    this.subscriptionDetailModal.hide();
  }

  public GetDriverSubscriptionDetail() {
    this.isLoading = true;
    this.driverService.GetDriverSubscriptionDetail(this.sharedvehiclegroupDriverHashId)
      .subscribe(
      (res: any) => {
        this.driverSubscription = res.data;
        this.isLoading = false;
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }
  // Assign shred vehicle group to driver
  public ShowAssignDriverGroupModal() {
    this.assignDriverGroupModal.driverMasterHashId = this.driverMasterHashId;
    this.assignDriverGroupModal.show();
  }

  public SuccessAssignDriverGroupModal($event: any) {
    this.GetDriverSVGList();
    this.popupMsg = this.translate.instant('LblRecordAddedSuccess', [this.module]); //$event.SuccessMessage;
    this.ShowSuccessPopup();

  }
  public OnCancel(): void {
    this.affectedbookingModal.hide();
  }
  public OnCancelSubscriptionInformation(): void {
    this.subscriptionDetailModal.hide();
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
  }
  public GetAffectedSubscriptionBookingListForSearch() {
    this.isLoading = true;
    this.driverService.GetAffectedSubscriptionBookingList(this.sharedvehiclegroupDriverHashId, this.subScriptionEndDate, this.DataListBooking)
      .subscribe(
      res => {

        this.bookingList = res.data;
        this.DataListBooking.totalItems = res.totalRecords;
        this.DataListBooking.infoMessage = res.error;
        this.affectedbookingModal.show();
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }
  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/driver/components/driverSVG-list.component.ts